
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instantdatasets/register",
      function () {
        return require("private-next-pages/instantdatasets/register.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instantdatasets/register"])
      });
    }
  